import type { EntityListResponse } from '@ydistri/api-sdk';
import type { MultiselectCustomerPartialEntity } from '../ConfigurationMultiselect/configurationMultiselectTypes';

type EntityListMultiselectDataInput = Pick<
  EntityListResponse,
  'customerEntityListId' | 'entityListId' | 'name'
>;

export const buildEntityListMultiselectData = (
  lists: EntityListMultiselectDataInput[],
): MultiselectCustomerPartialEntity[] =>
  lists.map(list => ({
    id: list.entityListId,
    title: list.name ?? '',
    customerId: list.customerEntityListId ?? list.entityListId.toString(),
    label: list.name ?? list.entityListId.toString(),
  }));
